import { render, staticRenderFns } from "./DetailMedicalInfo.vue?vue&type=template&id=6d20a065&scoped=true"
import script from "./DetailMedicalInfo.vue?vue&type=script&lang=js"
export * from "./DetailMedicalInfo.vue?vue&type=script&lang=js"
import style0 from "./DetailMedicalInfo.vue?vue&type=style&index=0&id=6d20a065&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d20a065",
  null
  
)

export default component.exports